<template>
  <modal title="Trash Post" size="xs" ref="modal">
    <h2 class="text-subtitle1">
      Are you sure you want to trash this post?
    </h2>
    <post :post="post" />
    <template v-slot:actions>
      <q-btn label="Trash" color="negative" :class="gtm.TRASH_POST" @click="trash" />
    </template>
  </modal>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { ModalMixin } from '@/mixins';
import { Post as PostType, Modal as ModalElement } from '@/type';
import Modal from '@/components/modal/Modal.vue';
import gtm from '@/tracking/gtm';
import Post from '../card/Post.vue';

interface Data {
  gtm: {[name: string]: string},
}

export default defineComponent({
  emits: ['ok'],
  mixins: [ModalMixin],
  components: {
    Modal,
    Post,
  },
  props: {
    post: {
      type: Object as () => PostType,
      required: true,
    },
  },
  data(): Data {
    return {
      gtm,
    };
  },
  methods: {
    trash() {
      this.$emit('ok');
      (this.$refs.modal as ModalElement).hide();
    },
  },
});
</script>
